// mixins.ts
import { Vue, Component } from "vue-property-decorator";
import { isPhone } from "@/utils/commonUtil";

// declare module 'vue/types/vue' {
//   interface Vue {
//     methodFromMixins(value: number | string): void;  // 记得声明一下，要不然会报错 Property 'methodFromMixins' does not exist on type 'App'.
//   }
// }

@Component({})
export default class pageMixins extends Vue {
  // public methodFromMixins(value: number | string): void {
  //   console.log('method from mixins', value);
  // }
  // 帖子、贴吧、新闻需要的data
  pageLayout = "total,sizes, prev, pager, next, jumper";
  pageSizes: number[] = [10, 20, 30, 50, 70, 100];
  total = 0;
  pageFunc: any = "";
  params = {
    pageSize: 10,
    pageNum: 1,
  };
  isPhoneBool = false;
  pageCount = 11;
  selectionDataKey = "id";
  selectionData = [];
  pageParam = {
    pageNum: 1,
    pageSize: 10,
    total: 0,
    unselectMode: false,
  };
  unselectionData = [];
  getThis() {
    return this as any;
  }
  public created() {
    // 默认table渲染函数
    this.getThis().pageFunc = this.getThis().getTableData;
    this.isPhoneBool = isPhone();
  }
  // 帖子、贴吧、新闻需要的方法
  public pageChange(val: number) {
    this.getThis().params.pageNum = val;
    console.log("pageParam", this.getThis().pageParam);
    this.getThis().pageFunc();
  }
  public sizesChange(val: number) {
    this.getThis().params.pageNum = 1;
    this.getThis().params.pageSize = val;
    console.log("pageParam", this.getThis().pageParam);
    this.getThis().pageFunc();
  }
  // 查询条件
  public searchChange(obj: object) {
    if (this.getThis().$refs.tagFilter) {
      this.getThis().$refs.tagFilter.forEach((item: any) => {
        item.toReset();
      }); // 重置筛选
    }

    if (Object.prototype.hasOwnProperty.call(this.getThis().params, "createTime_begin")) {
      this.getThis().params.createTime_begin = this.getThis().params.createTime_end = "";
    }

    Object.assign(this.getThis().params, obj);
    this.getThis().params.pageNum = 1;
    this.getThis().pageFunc();
  }
  public clearSearch(obj: object) {
    if (this.getThis().$refs.tagFilter) {
      this.getThis().$refs.tagFilter.forEach((item: any) => {
        item.toReset();
      }); // 重置筛选
    }

    if (Object.prototype.hasOwnProperty.call(this.getThis().params, "createTime_begin")) {
      this.getThis().params.createTime_begin = this.getThis().params.createTime_end = "";
    }

    if (this.getThis().$refs.cardSeacherPanle) {
      this.getThis().$refs.cardSeacherPanle.inputVal = "";
      for (let i = 0; i < this.getThis().searchRange.list.length; i++) {
        const element = this.getThis().searchRange.list[i].key;
        delete this.getThis().params[element];
      }
    }

    Object.assign(this.getThis().params, obj);
    this.getThis().params.pageNum = 1;
    this.getThis().pageFunc();
  }
  public tagCallback(obj: any, type: any) {
    // 时间选择器返回为数组，后台不接受数组格式，所以拆分，搜索时需要手动清空
    if (type == "createTime") {
      this.getThis().params.createTime_begin = obj.id[0];
      this.getThis().params.createTime_end = obj.id[1];
      this.getThis().params.createTime = "";
    }

    this.getThis().params.pageNum = 1;
    this.getThis().pageFunc();
  }
  // 判断对象
  isNullObj(obj: object) {
    if (!obj) return obj;

    return Object.keys(obj).length;
  }

  mutiSelectToggles(switchName = "更改状态", switchType = "该选项", apis: any, params: any = {}) {
    if (!this.selectionData || this.selectionData.length == 0) {
      this.$message({
        message: "请先勾选需要操作的内容",
        type: "warning",
      });
      return;
    }
    this.$confirm("是否确认批量" + switchName + switchType, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        apis({
          ...params,
          ids: this.selectionData,
        }).then((res: any) => {
          console.log("mutiSelectToggles", res);

          if (res.code == 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getThis().pageFunc();
          }
        });
      })
      .catch(() => {
        this.$message({
          message: "已取消批量操作",
          type: "warning",
        });
      });
  }

  //其他需要的方法
  public handleSizeChange(val: number) {
    this.getThis().pageParam.pageNum = 1;
    this.getThis().pageParam.pageSize = val;
    console.log("pageParam", this.getThis().pageParam);
    this.getThis().getTableData();
  }
  public changePage(pageIndex: number) {
    this.getThis().pageParam.pageNum = pageIndex;
    this.getThis().getTableData();
  }
  public screenQuery() {
    this.getThis().params.pageNum = 1;
    this.getThis().getTableData();
  }
  public typeSeacher(data: any) {
    this.getThis().searchRange.param = data;
    this.getThis().emptyScreen();
  }
  // 重置筛选
  public emptyScreen() {
    if (this.getThis().$refs.tagFilter) {
      this.getThis().$refs.tagFilter.forEach((item: any) => {
        item.toReset();
      });
    }
    this.getThis().screenQuery();
  }
  public handleUnselectionModeChange(val: boolean) {
    this.getThis().pageParam.unselectMode = val;
  }
  public handleUnselectionChange(val: any) {
    const ids = val.map((item: any) => {
      return item.id;
    });
    this.unselectionData = ids;
  }
  public handleSelectionChange(val: any) {
    const ids = val.map((item: any) => {
      return item.id;
    });
    this.selectionData = ids;
  }
  public onConditionChange(condition: any) {
    this.getThis().getTableData();
  }
  public onSearch() {
    this.params.pageNum = 1;
    this.pageParam.pageNum = 1;
    this.getThis().getTableData();
  }
  tableSetting = {
    rowKey(row: any) {
      return row.id;
    },
  };
}

/*
  1.
  <el-pagination
    class="mt20 ta_r"
    v-if="total > 0"
    :layout="pageLayout"
    :current-page="params.pageNum"
    :page-size="params.pageSize"
    :total="total"
    :page-sizes="pageSizes"
    @size-change="sizesChange"
    @current-change="pageChange"
    background
  >
  </el-pagination>
*/

/*
  2.添加mixins
  mixins: [pageMixins]
*/

/*
  3.修改渲染函数（可选，默认getTableData）
  created() {
    this.pageFunc = this.other;
  }
*/

/*
  4.总页数
   this.total = res.total.
*/
